export default {
  brand: {
    name: 'USFansLink',
  },
  nav: {
    home: 'Inicio',
    guide: 'Guía de USFans Spreadsheet',
    shoppingGuide: 'Guía de compras',
    categories: 'Categorías',
    faq: 'Preguntas frecuentes',
    buyNow: 'Comprar ahora',
    spread: 'USFans Spreadsheet',
  },
  lang: {
    label: 'Idioma',
    en: 'English',
    pl: 'Polski',
    es: 'Español',
    fr: 'Français',
  },
  trust: {
    independent: 'Recurso independiente',
    updated: 'Actualizado con regularidad',
    multilingual: 'Multilingüe',
  },
  footer: {
    tagline: 'Un recurso informativo independiente para usuarios de la hoja de cálculo USFans.',
    explore: 'Explorar',
    shop: 'Categorías de la tienda',
    mainSite: 'Visitar el sitio principal',
    guide: 'Leer la guía',
    disclaimer: 'USFansLink es un recurso informativo independiente. No garantizamos la disponibilidad, autenticidad, calidad, precio, desempeño del envío ni seguridad de ningún producto, vendedor o servicio de terceros. Verifique siempre la información importante de forma independiente antes de comprar.',
    rights: 'Todos los derechos reservados.',
  },
};